import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { AuthShell, GoogleButton } from "@/components/AuthShell";

export default function Register() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      loginWithToken(data.token, data.user);
      toast.success("Compte créé ! Bienvenue sur Monaga Adflow.");
      navigate("/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Échec de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Créer un compte" subtitle="Lancez-vous — 150 crédits IA offerts.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="name">Nom / Marque</Label>
          <Input id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5 h-11 rounded-xl" placeholder="Votre nom ou marque" data-testid="register-name" />
        </div>
        <div>
          <Label htmlFor="email">E-mail professionnel</Label>
          <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5 h-11 rounded-xl" placeholder="vous@marque.com" data-testid="register-email" />
        </div>
        <div>
          <Label htmlFor="password">Mot de passe</Label>
          <Input id="password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5 h-11 rounded-xl" placeholder="6 caractères minimum" data-testid="register-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-11 rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 text-white border-0" data-testid="register-submit">
          {loading ? "Création…" : "Créer mon compte gratuit"}
        </Button>
      </form>

      <div className="flex items-center gap-3 my-5">
        <div className="h-px flex-1 bg-border" />
        <span className="text-xs text-muted-foreground">ou</span>
        <div className="h-px flex-1 bg-border" />
      </div>

      <GoogleButton label="S'inscrire avec Google" />

      <p className="text-center text-sm text-muted-foreground mt-6">
        Déjà un compte ? <Link to="/login" className="text-primary font-medium hover:underline" data-testid="goto-login">Se connecter</Link>
      </p>
    </AuthShell>
  );
}
